import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 768;

// useSyncExternalStore is the canonical way to subscribe React to a
// browser-side source-of-truth. Reading window.innerWidth synchronously
// in the snapshot getter avoids the previous "setState inside an
// effect to seed initial value" pattern, which the React Compiler
// flags as a cascading-render risk.

function getSnapshot(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function getServerSnapshot(): boolean {
  return false;
}

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
